<template>
  <vx-card id="print-report" class="w-full">
    <!-- 버튼 리스트 -->
    <div class="flex flex-wrap items-center mb-5 gap-4">
      <h4>(중대)산업재해 발생 등 비상상황 대응지침</h4>
      <div v-if="!isPrint" class="w-full sm:w-auto ml-0 sm:ml-auto flex gap-2">
        <div v-if="!editMode" class="w-full flex gap-2">
          <vs-button class="flex-1" color="secondary" type="border" @click="onClickPrint">인쇄</vs-button>
          <vs-button class="flex-1" v-if="hasPermission" color="secondary" @click="onClickEdit">편집</vs-button>
        </div>
        <div v-else class="w-full">
          <vs-button class="flex-1" color="secondary" @click="onClickSave">저장</vs-button>
        </div>
      </div>
    </div>

    <!-- [제·개정 이력] -->
    <div class="flex justify-between items-center mb-3">
      <h5><i class="dot"></i>[제·개정 이력]</h5>
      <div v-if="editMode" class="ml-auto">
        <vs-button color="secondary" @click="addRow"> 항목추가 </vs-button>
        <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow" :disabled="checkList.length === 0"> 선택삭제 </vs-button>
      </div>
    </div>

    <div class="w-full overflow-x-auto">
      <table>
        <colgroup>
          <col v-if="editMode" width="80px" />
          <col width="100px" />
          <col width="160px" />
          <col width="400px" />
          <col width="100px" />
          <col width="100px" />
        </colgroup>
        <thead>
        <tr>
          <th v-if="editMode" class="bg-th">
            <vs-checkbox class="custom-checkbox" :value="allCheck" @click.native="onClickAllCheck"></vs-checkbox>
          </th>
          <th>연번</th>
          <th>제·개정일</th>
          <th>제·개정 사유</th>
          <th>비고</th>
          <th>첨부파일</th>
        </tr>
        </thead>
        <draggable v-model="form.list" tag="tbody" handle=".handle">
          <tr v-for="(row, indexRow) in form.list" :key="indexRow">
            <td v-if="editMode" class="bg-th">
              <div class="flex items-center justify-center gap-4">
                <feather-icon class="handle" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
                <vs-checkbox class="custom-checkbox" v-model="checkList" :vs-value="row.id"></vs-checkbox>
              </div>
            </td>
            <td class="bg-th">{{ indexRow + 1 }}</td>
            <td :class="editMode ? 'editMode' : ''">
              <date-selector v-if="editMode" v-model="row.제개정일" />
              <p v-else>{{ row.제개정일 || "-" }}</p>
            </td>
            <td class="text-left" :class="editMode ? 'editMode' : ''">
              <ml-textarea v-if="editMode" v-model="row.제개정사유" :rows="3" class="mb-0" />
              <p v-else class="whitespace-pre-wrap">{{ row.제개정사유 || "-" }}</p>
            </td>
            <td class="text-left" :class="editMode ? 'editMode' : ''">
              <ml-textarea v-if="editMode" v-model="row.비고" :rows="3" class="mb-0" />
              <p v-else class="whitespace-pre-wrap">{{ row.비고 || "-" }}</p>
            </td>
            <td :class="editMode ? 'editMode' : ''">
              <file-uploader v-if="editMode" v-model="row.file" />
              <div v-else-if="row.file.path" class="file" @click="() => onClickFileDownload(row.file.fileName, row.file.path)">
                <span>{{ row.file.fileName }}</span>
                ({{ fileSizeConvert(row.file.fileSize) }})
              </div>
            </td>
          </tr>
        </draggable>
      </table>
    </div>
  </vx-card>
</template>

<script>
import draggable from "vuedraggable";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector";
import { downloadFile } from "@/util/DataUtil";

export default {
  components: {
    draggable,
    FileUploader,
    DateSelector,
  },
  data() {
    return {
      isPrint: false,
      editMode: false,
      permission: { c: 0, r: 0, u: 0, d: 0, v: 0 },

      checkList: [],

      form: {
        lastId: 4,
        list: [
          {
            id: 0,
            제개정일: "2022-02-01",
            제개정사유: "(제정)",
            비고: "",
            file: {},
          },
          {
            id: 1,
            제개정일: "2022-08-01",
            제개정사유: "(1차 개정)\n- 용어의 정의 구체화\n- 작업중지 및 대피 내용 수정 : 근로자 작업중지 및 대피권 보장",
            비고: "",
            file: {},
          },
          {
            id: 2,
            제개정일: "",
            제개정사유: "",
            비고: "",
            file: {},
          },
          {
            id: 3,
            제개정일: "",
            제개정사유: "",
            비고: "",
            file: {},
          },
          {
            id: 4,
            제개정일: "",
            제개정사유: "",
            비고: "",
            file: {},
          },
        ],
      },
    };
  },
  computed: {
    hasPermission() {
      return this.permission.c === 1;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    allCheck() {
      return 0 < this.form.list.length && this.checkList.length === this.form.list.length;
    },
  },
  created() {
    this.loadPermission();
    this.loadPost();
  },
  methods: {
    async loadPermission() {
      if (Number.isInteger(this.boardId)) {
        let boards = this.$store.state.member.memberInfo.boards;
        if (!boards) {
          await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
          boards = this.$store.state.member.memberInfo.boards;
        }

        let board = boards.find((b) => parseInt(b.id) === parseInt(this.boardId));
        if (!!board && !!board.pivot) {
          if (board.pivot.project_id) {
            // 프로젝트에 맞는 권한이 있는지 다시 조사한다
            board = boards.find((b) => parseInt(b.pivot.board_id) === parseInt(this.boardId) && parseInt(b.pivot.project_id) === parseInt(this.projectId));
            this.permission = { ...board.pivot };
          } else {
            this.permission = { ...board.pivot };
          }
        }
      }
    },
    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; }}");
    },
    print(css) {
      this.isPrint = true;
      setTimeout(() => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (let i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML.trimStart().trimEnd().replace(/\r\n/gi, "<br>").replace(/\\n/gi, "<br>").replace(/\n/gi, "<br>");

          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }

        const g_label = document.getElementById("print-label") ? document.getElementById("print-label").innerHTML : "";
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = "";
          if (g_label) {
            document.body.innerHTML += `${g_label}<br>`;
          }
          document.body.innerHTML += g_oBeforeBody;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        window.print();
        location.reload();
      }, 300);
    },
    onClickPrint() {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-vertical.svg" },
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-horizontal.svg" },
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },
    onClickEdit() {
      this.editMode = true;
    },
    addRow() {
      this.form.list.push({
        id: ++this.form.lastId,
        제개정일: "",
        제개정사유: "",
        비고: "",
        file: {},
      });
    },
    onClickAllCheck() {
      if (this.allCheck) this.checkList = [];
      else this.checkList = this.form.list.map((item) => item.id);
    },
    deleteRow() {
      this.form.list = this.form.list.filter((item) => !this.checkList.includes(item.id));
      this.checkList = [];
    },
    onClickFileDownload(filename, path) {
      downloadFile(filename, path);
    },

    // 게시물 불러오기
    async loadPost() {
      const params = {
        projectId: this.projectId,
        boardId: this.boardId,
        page: 1,
        perPage: 1,
        orderTarget: "created_at",
        orderDirection: "desc",
      };

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", params);
      const { data } = response;

      if (0 < data.length) {
        const post = JSON.parse(data[0].post_content).body;
        this.form = post;
      }
    },

    async onClickSave() {
      const form = {
        header: {
          full: new Date().format("yyyy-MM-dd"),
          month: new Date().getMonth() + 1,
          year: new Date().getFullYear(),
        },
        body: this.form,
        summary: {},
      };

      const projectId = this.projectId;
      const boardId = this.boardId;

      const title = "(중대)산업재해 발생 등 비상상황 대응지침";
      const content = JSON.stringify(form);

      await this.$store.dispatch("board/CREATE_POST", {
        projectId,
        boardId,
        title,
        content,
      });

      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "알림",
          message: "저장이 완료되었습니다.",
        },
      });
      window.dispatchEvent(customAlert);

      this.editMode = false;
      this.checkList = [];
    },

    fileSizeConvert(size) {
      let sizeCheck = size;
      if (sizeCheck < 1000) sizeCheck = `${sizeCheck}B`;
      else if (sizeCheck < 1000000) sizeCheck = `${(sizeCheck * 0.001).toFixed(1)}KB`;
      else sizeCheck = `${(sizeCheck * 0.000001).toFixed(1)}MB`;

      return sizeCheck;
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: calc(100% - 1px);
  table-layout: fixed;
  border-collapse: collapse;

  &,
  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding: 14px;

    border: 1px solid #cdcdcd;
  }

  .editMode {
    padding: 7px;
  }

  th,
  .bg-th {
    background: #f9f9f9;
  }

  td {
    font-weight: 400;
  }
}

.custom-checkbox::v-deep {
  justify-content: center !important;
  margin: 0px !important;
  .vs-checkbox {
    margin: 0 !important;
  }
}

.file {
  font-size: 12px;
  font-weight: 400;
  color: #9ca0a4;
  cursor: pointer;

  span {
    color: #7e72f2;
    text-decoration: underline;
    margin-right: 4px;
  }
}
</style>
